import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useEMailTemplate = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [tmpplateList, setTemplateList] = useState<MailTemplateDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.emailtemplate.list, location.search],
    () =>
      fetcher.emailtemplate.postEMailTemplateList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',        
        group: searchParams.group ? String(searchParams.group) : '',       
      }),
    {
      onSuccess: (res: MailTempalteListResDto) => {
        switch (res.code) {
          case 200:
            setTemplateList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, tmpplateList, searchResult, refetch  };
};

export default useEMailTemplate;
